import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Grid2,
  Radio,
  Typography,
} from "@mui/material";
import "@containers/Checkout/Checkout.scss";

const WalletCard = ({ image, value, checked, onChange, disabled, loading }) => (
  <Grid2 size={12} display={"flex"} className={disabled ? "disabled-grid" : ""}>
    <Card className={checked ? "active-custom-card" : "custom-card"}>
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          flex: "1 0 auto",
          padding: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? "none" : "auto",
          }}
        >
          <Radio
            checked={checked}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            mx: 2,
            borderColor: "#184097",
            borderWidth: 3,
          }}
        />
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <CardMedia
            component="img"
            sx={{ width: { xs: 80, sm: 120 } }}
            image={image}
            alt={`${value} Logo`}
          />

          {loading && (
            <Typography variant="body1" sx={{ marginLeft: 2 }}>
              Loading...
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  </Grid2>
);

export default WalletCard;
